<template>
    <div class="compliance-content">

        <!-- 页面横幅 -->
        <section class="bg-gradient-to-br from-[#0D47A1] to-[#1976D2] py-20 text-white relative overflow-hidden">
            <div class="absolute inset-0 opacity-30">
                <span class="iconify absolute right-1/4 top-1/4 text-[200px]" data-icon="ri:robot-3-fill"></span>
            </div>
            <div class="max-w-[1200px] mx-auto px-4 relative z-10">
                <div class="flex items-center space-x-4 mb-6 opacity-80">
                </div>
                <h2 class="text-5xl font-extrabold mb-6">数据合规审查</h2>
                <div class="flex items-center space-x-4 mb-6">
                    <span
                        class="px-3 py-1 bg-blue-400/30 border border-blue-400/50 rounded-full text-sm font-bold tracking-wider">AI
                        POWERED</span>
                    <span class="text-blue-200">|</span>
                    <span class="text-lg">人工智能赋能</span>
                </div>

                <p class="text-xl text-blue-100 max-w-2xl leading-relaxed">
                    基于前沿大模型技术，通过深度学习相关法律法规，实现对数据处理全流程的自动化合规审查。智能识别数据采集、存储、处理及流转中的合规风险，以技术驱动的方式提升审查效率与精准度，为数据合规运营提供可靠保障。
                </p>
            </div>
        </section>
        <!-- ==================== AI 核心审查能力展示 ==================== -->
        <section class="py-16 bg-white">
            <div class="max-w-[1200px] mx-auto px-4 text-center mb-12">
                <div class="mb-8">
                    <div class="flex items-center justify-center mb-4">
                        <span class="text-2xl text-[#1565C0] font-bold mr-2">●</span>
                        <h3 class="text-2xl font-bold text-gray-800">AI 核心审查技术矩阵</h3>
                    </div>
                    <p class="text-[#666666]">基于深度学习的多模态数据解析引擎</p>
                </div>
                <div class="max-w-[1200px] mx-auto px-4 grid grid-cols-3 gap-8 mb-20">
                    <div
                        class="flex items-start space-x-4 p-6 rounded-xl bg-gray-50 border border-transparent hover:border-blue-500 transition-all">
                        <span class="iconify text-4xl text-blue-600" data-icon="ri:character-recognition-line"></span>
                        <div>
                            <h5 class="font-bold text-lg mb-2">自然语言处理 (NLP)</h5>
                            <p class="text-sm text-gray-500">智能解析非结构化政策文档，自动比对条文细节，识别合同及授权文件风险。</p>
                        </div>
                    </div>
                    <div
                        class="flex items-start space-x-4 p-6 rounded-xl bg-gray-50 border border-transparent hover:border-blue-500 transition-all">
                        <span class="iconify text-4xl text-blue-600" data-icon="ri:scan-2-line"></span>
                        <div>
                            <h5 class="font-bold text-lg mb-2">OCR 图像识别</h5>
                            <p class="text-sm text-gray-500">自动提取证明材料、证照、签名等视觉信息，确保证据链闭环及真实性。</p>
                        </div>
                    </div>
                    <div
                        class="flex items-start space-x-4 p-6 rounded-xl bg-gray-50 border border-transparent hover:border-blue-500 transition-all">
                        <span class="iconify text-4xl text-blue-600" data-icon="ri:bubble-chart-line"></span>
                        <div>
                            <h5 class="font-bold text-lg mb-2">数据模式分析</h5>
                            <p class="text-sm text-gray-500">通过机器学习监测异常数据分布，自动挖掘潜在的安全泄露风险与关联特征。</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- ==================== AI 审查流程流转图 ==================== -->
        <section class="py-20  bg-gray-50">
            <div class="max-w-[1200px] mx-auto px-4">
                <div class="text-center mb-16">
                    <div class="flex items-center justify-center mb-4">
                        <span class="text-2xl text-[#1565C0] font-bold mr-2">●</span>
                        <h3 class="text-2xl font-bold text-gray-800">人工智能审查流程</h3>
                    </div>
                    <p class="text-[#666666] text-sm">AI NATIVE REVIEW PIPELINE</p>
                </div>
                <div class="flex items-center justify-between relative">
                    <div
                        class="absolute top-[40px] left-0 w-full h-1 bg-gradient-to-r from-blue-100 via-blue-400 to-green-100 z-0">
                    </div>
                    <!-- Step 1 -->
                    <div class="flex flex-col items-center w-48 text-center relative z-10">
                        <div
                            class="w-20 h-20 rounded-full bg-white border-4 border-blue-500 flex items-center justify-center shadow-lg transition-transform hover:scale-110">
                            <span class="iconify text-3xl text-blue-500" data-icon="ri:upload-2-fill"></span>
                        </div>
                        <h5 class="font-bold mt-4 mb-2">数据资料上传</h5>
                        <p class="text-[10px] text-gray-400">支持批量结构化与非结构化附件提报</p>
                    </div>
                    <!-- Step 2 -->
                    <div class="flex flex-col items-center w-48 text-center relative z-10">
                        <div
                            class="w-20 h-20 rounded-full bg-blue-600 flex items-center justify-center shadow-lg transition-transform hover:scale-110">
                            <div class="animate-pulse">
                                <span class="iconify text-3xl text-white" data-icon="ri:cpu-line"></span>
                            </div>
                        </div>
                        <h5 class="font-bold mt-4 mb-2 text-blue-700">AI 自动扫描</h5>
                        <p class="text-[10px] text-gray-400">毫秒级内容感知，覆盖全国政策库</p>
                    </div>
                    <!-- Step 3 -->
                    <div class="flex flex-col items-center w-48 text-center relative z-10">
                        <div
                            class="w-20 h-20 rounded-full bg-white border-4 border-orange-400 flex items-center justify-center shadow-lg transition-transform hover:scale-110">
                            <span class="iconify text-3xl text-orange-400" data-icon="ri:radar-line"></span>
                        </div>
                        <h5 class="font-bold mt-4 mb-2">智能风险识别</h5>
                        <p class="text-[10px] text-gray-400">红色高危预警及合规建议自动生成</p>
                    </div>
                    <!-- Step 4 -->

                    <div class="flex flex-col items-center w-48 text-center relative z-10">
                        <div
                            class="w-20 h-20 rounded-full bg-green-500 flex items-center justify-center shadow-lg transition-transform hover:scale-110 border-4 border-white">
                            <span class="iconify text-3xl text-white" data-icon="ri:user-voice-line"></span>

                        </div>


                        <h5 class="font-bold mt-4 mb-2">人工复核确认</h5>
                        <p class="text-[10px] text-gray-400">结果人工复合，提升审查准确性</p>
                    </div>
                    <!-- Step 5 -->
                    <div class="flex flex-col items-center w-48 text-center relative z-10">
                        <div
                            class="w-20 h-20 rounded-full bg-white border-4 border-purple-500 flex items-center justify-center shadow-lg transition-transform hover:scale-110">
                            <span class="iconify text-3xl text-purple-500" data-icon="ri:file-list-3-line"></span>
                        </div>
                        <h5 class="font-bold mt-4 mb-2">合规报告生成</h5>
                        <p class="text-[10px] text-gray-400">一键导出具有法律效力的审查详单</p>
                    </div>
                </div>
            </div>
        </section>

        <!-- ==================== 精准化审查维度 ==================== -->
        <section class="py-20 bg-white">
            <div class="max-w-[1200px] mx-auto px-4">
                <div class="text-center mb-16">
                    <div class="flex items-center justify-center mb-4">
                        <span class="text-2xl text-[#1565C0] font-bold mr-2">●</span>
                        <h3 class="text-2xl font-bold text-gray-800">多维度审查</h3>
                    </div>
                    <p class="text-[#666666]">全方位覆盖数据合规审查的关键领域</p>
                </div>
                <div class="grid grid-cols-4 gap-6">
                    <div
                        class="bg-white p-8 border border-gray-100 hover:border-blue-200 hover:shadow-lg transition-all rounded-xl group">
                        <div
                            class="mb-6 inline-block p-3 bg-blue-50 text-[#1565C0] rounded-lg group-hover:bg-[#1565C0] group-hover:text-white transition-colors">
                            <span class="iconify text-3xl" data-icon="ri:scales-3-line"></span>
                        </div>
                        <h4 class="text-lg font-bold mb-3">合法性审查</h4>
                        <p class="text-sm text-[#666666] leading-relaxed">核验数据采集渠道、处理授权及权利归属的法律依据，防范侵权风险。</p>
                    </div>
                    <div
                        class="bg-white p-8 border border-gray-100 hover:border-blue-200 hover:shadow-lg transition-all rounded-xl group">
                        <div
                            class="mb-6 inline-block p-3 bg-green-50 text-[#00BFA5] rounded-lg group-hover:bg-[#00BFA5] group-hover:text-white transition-colors">
                            <span class="iconify text-3xl" data-icon="ri:lock-password-line"></span>
                        </div>
                        <h4 class="text-lg font-bold mb-3">安全性审查</h4>
                        <p class="text-sm text-[#666666] leading-relaxed">评估分类分级保护落实情况，严控涉及国家安全、商业秘密与个人隐私的数据。</p>
                    </div>
                    <div
                        class="bg-white p-8 border border-gray-100 hover:border-blue-200 hover:shadow-lg transition-all rounded-xl group">
                        <div
                            class="mb-6 inline-block p-3 bg-orange-50 text-[#FF9800] rounded-lg group-hover:bg-[#FF9800] group-hover:text-white transition-colors">
                            <span class="iconify text-3xl" data-icon="ri:organization-chart"></span>
                        </div>
                        <h4 class="text-lg font-bold mb-3">规范性审查</h4>
                        <p class="text-sm text-[#666666] leading-relaxed">校验元数据标准、格式规范及数据质量完整性，确保数据描述精准可用。</p>
                    </div>
                    <div
                        class="bg-white p-8 border border-gray-100 hover:border-blue-200 hover:shadow-lg transition-all rounded-xl group">
                        <div
                            class="mb-6 inline-block p-3 bg-purple-50 text-purple-600 rounded-lg group-hover:bg-purple-600 group-hover:text-white transition-colors">
                            <span class="iconify text-3xl" data-icon="ri:government-line"></span>
                        </div>
                        <h4 class="text-lg font-bold mb-3">政策性审查</h4>
                        <p class="text-sm text-[#666666] leading-relaxed">研判数据用途是否契合国家产业导向，支持公共数据在特定领域的授权运营。</p>
                    </div>
                </div>
            </div>
        </section>

        <!-- ==================== 优势对比 ==================== -->
        <section class="py-20  bg-gray-50">
            <div class="max-w-[1200px] mx-auto px-4 text-center mb-16">
                <div class="flex items-center justify-center mb-4">
                    <span class="text-2xl text-[#1565C0] font-bold mr-2">●</span>
                    <h3 class="text-2xl font-bold text-gray-800">合规审查体系</h3>
                </div>
                <p class="text-[#666666]">传统审核与AI智能审查的差异对比</p>
            </div>
            <div class="max-w-[1200px] mx-auto px-4 grid grid-cols-2 gap-16 items-center">
                <div class="space-y-6">
                    <h3 class="text-3xl font-bold text-[#1565C0]">为什么选择我们的<br />审查体系？</h3>
                    <p class="text-[#666666] leading-relaxed">
                        传统的纸质审核存在标准不一、周期长、不可追溯等痛点。我们的模块通过数字化重塑，实现了“审管联动”的新范式。
                    </p>
                    <ul class="space-y-4">
                        <li class="flex items-center space-x-3">
                            <span class="iconify text-blue-600 text-xl" data-icon="ri:flashlight-fill"></span>
                            <span class="font-medium">高效准确：AI初核缩短审查周期至分钟级</span>
                        </li>
                        <li class="flex items-center space-x-3">
                            <span class="iconify text-blue-600 text-xl" data-icon="ri:time-line"></span>
                            <span class="font-medium">24小时不间断：随报随审，全天候响应申报需求</span>
                        </li>
                        <li class="flex items-center space-x-3">
                            <span class="iconify text-blue-600 text-xl" data-icon="ri:alarm-warning-line"></span>
                            <span class="font-medium">智能风险预警：自动拦截违规字段并提供合规修改建议</span>
                        </li>
                        <li class="flex items-center space-x-3">
                            <span class="iconify text-blue-600 text-xl" data-icon="ri:node-tree"></span>
                            <span class="font-medium">审管联动：与政策库实时同步，审查标准始终保持最新</span>
                        </li>
                    </ul>
                    <div class="pt-6">
                        <button @click="toCompnyIndex"
                            class="bg-[#1565C0] text-white px-8 py-3 rounded-lg font-bold shadow-lg hover:bg-[#0D47A1] transition-transform active:scale-95">申请合规审查</button>
                    </div>
                </div>
                <div class="bg-white p-2 rounded-2xl shadow-2xl relative">
                    <img alt="Illustration of high-tech data security and compliance review dashboard"
                        class="w-full h-auto rounded-xl" id="img-1"
                        src="https://modao.cc/agent-py/media/generated_images/2025-12-19/9360633000694848b76ad5ad79da385b.jpg" />
                    <div
                        class="absolute -bottom-6 -left-6 bg-white p-6 rounded-lg shadow-xl border border-gray-100 flex items-center space-x-4">
                        <div class="bg-blue-100 p-3 rounded-full text-[#1565C0]">
                            <span class="iconify text-2xl" data-icon="ri:timer-flash-line"></span>
                        </div>
                        <div>
                            <div class="text-2xl font-bold text-[#1565C0]">200%</div>
                            <div class="text-xs text-[#999999]">审核效率平均提升</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- ==================== 底部联系区 ==================== -->
        <section class="py-16 bg-white">
            <div class="max-w-[1200px] mx-auto px-4 text-center mb-12">
                <div class="flex items-center justify-center mb-4">
                    <span class="text-2xl text-[#1565C0] font-bold mr-2">●</span>
                    <h3 class="text-2xl font-bold text-gray-800">数据合规咨询</h3>
                </div>
                <p class="text-[#666666]">专家一对一解答复杂合规难题</p>
            </div>
            <div class="max-w-[1200px] mx-auto px-4">
                <div class="bg-white border rounded-xl p-8 flex items-center justify-between">
                    <div class="flex items-center space-x-6">
                        <div class="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center text-[#1565C0]">
                            <span class="iconify text-3xl" data-icon="ri:question-answer-line"></span>
                        </div>
                        <div>
                            <h4 class="text-xl font-bold">合规咨询</h4>
                            <p class="text-sm text-[#999999] mt-1">遇到复杂的合规难题？申请专家为您一对一解答。</p>
                        </div>
                    </div>
                    <div class="flex space-x-4">
                        <!-- <button @click="showMessageModal = true"
                            class="px-6 py-2 border-2 border-[#1565C0] text-[#1565C0] font-bold rounded-lg hover:bg-gray-50 transition-colors">专家咨询</button> -->
                        <button @click="showMessageModal = true"
                            class="px-6 py-2 bg-[#1565C0] text-white font-bold rounded-lg hover:bg-[#0D47A1] transition-colors">专家咨询</button>
                        <!-- <button @click="toCompnyIndex"
                            class="px-6 py-2 bg-[#1565C0] text-white font-bold rounded-lg hover:bg-[#0D47A1] transition-colors">立即申请</button> -->
                    </div>
                </div>
            </div>
        </section>

        <!-- 在线留言弹窗 -->
        <div v-if="showMessageModal"
            class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div class="bg-white rounded-2xl w-full max-w-md shadow-2xl">
                <!-- 弹窗头部 -->
                <div class="flex items-center justify-between p-6 border-b border-gray-100">
                    <div class="flex items-center space-x-3">
                        <div class="w-10 h-10 bg-blue-50 rounded-full flex items-center justify-center text-[#1565C0]">
                            <span class="iconify text-xl" data-icon="ri:message-3-line"></span>
                        </div>
                        <h3 class="text-xl font-bold text-gray-800">专家咨询</h3>
                    </div>
                    <button @click="showMessageModal = false"
                        class="text-gray-400 hover:text-gray-600 transition-colors">
                        <span class="iconify text-2xl" data-icon="ri:close-line"></span>
                    </button>
                </div>

                <!-- 表单内容 -->
                <div class="p-6">
                    <form @submit.prevent="submitMessage" class="space-y-5">
                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-2">姓名 <span
                                    style="color: red;">*</span></label>
                            <input v-model="messageForm.name" type="text" required
                                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                                placeholder="请输入您的姓名">
                        </div>

                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-2">联系方式 <span
                                    style="color: red;">*</span></label>
                            <input v-model="messageForm.contact" type="text" required
                                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                                placeholder="请输入手机号或邮箱">
                        </div>

                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-2">公司/机构</label>
                            <input v-model="messageForm.company" type="text"
                                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                                placeholder="请输入公司或机构名称（选填）">
                        </div>

                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-2">咨询内容 <span
                                    style="color: red;">*</span></label>
                            <textarea v-model="messageForm.content" required rows="4"
                                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all resize-none"
                                placeholder="请简要描述您的合规咨询需求..."></textarea>
                        </div>

                        <div class="pt-2">
                            <button type="submit" :disabled="isSubmitting"
                                class="w-full bg-[#1565C0] text-white py-3 rounded-lg font-bold hover:bg-[#0D47A1] transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
                                <span v-if="!isSubmitting">提交咨询</span>
                                <span v-else class="flex items-center justify-center">
                                    <span class="iconify animate-spin mr-2" data-icon="ri:loader-4-line"></span>
                                    提交中...
                                </span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <!-- 提交成功提示 -->
        <div v-if="showSuccessToast" class="fixed top-6 right-6 z-50 animate-slide-in">
            <div class="bg-green-50 border border-green-200 rounded-xl p-4 shadow-lg flex items-center space-x-3">
                <div class="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center text-green-600">
                    <span class="iconify text-xl" data-icon="ri:checkbox-circle-fill"></span>
                </div>
                <div>
                    <p class="font-medium text-green-800">咨询提交成功！</p>
                    <p class="text-sm text-green-600">我们将尽快与您联系</p>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
export default {
    data() {
        return {
            showMessageModal: false,
            showSuccessToast: false,
            isSubmitting: false,
            messageForm: {
                name: '',
                contact: '',
                company: '',
                content: ''
            }
        }
    },
    watch: {
        showMessageModal(newVal) {
            if (newVal) {
                // 记录当前滚动位置
                this.scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                // 禁止背景滚动
                document.body.style.overflow = 'hidden';
                document.body.style.position = 'fixed';
                document.body.style.top = `-${this.scrollTop}px`;
                document.body.style.width = '100%';
            } else {
                // 恢复背景滚动
                document.body.style.overflow = '';
                document.body.style.position = '';
                document.body.style.top = '';
                document.body.style.width = '';
                // 恢复滚动位置
                window.scrollTo(0, this.scrollTop);
            }
        }
    },
    methods: {
        toCompnyIndex() {
            this.$router.push('/index/home');
        },

        async submitMessage() {
            if (this.isSubmitting) return;

            this.isSubmitting = true;

            try {
                // 构建咨询数据
                const consultationData = {
                    name: this.messageForm.name,
                    contact: this.messageForm.contact,
                    problemDescription: this.messageForm.content,
                    subjectName: this.messageForm.company || '未填写',
                    consultationTime: this.getCurrentTime(),
                    status: 0 // 默认未处理
                };

                console.log('提交咨询请求参数:', consultationData);

                // 调用API接口
                const response = await this.$axios.post('/web/consultation/save', consultationData);
                console.log('提交咨询响应:', response.data);

                if (response.data && response.data.status === 200) {
                    // 显示成功提示
                    this.showSuccessToast = true;

                    // 重置表单
                    this.messageForm = {
                        name: '',
                        contact: '',
                        company: '',
                        content: ''
                    };

                    // 关闭弹窗
                    this.showMessageModal = false;

                    // 3秒后自动隐藏成功提示
                    setTimeout(() => {
                        this.showSuccessToast = false;
                    }, 3000);
                } else {
                    this.$message.error(response.data?.msg || '提交咨询失败');
                }

            } catch (error) {
                console.error('提交咨询失败:', error);
                this.$message.error('提交咨询失败，请稍后重试');
            } finally {
                this.isSubmitting = false;
            }
        },

        // 获取当前时间（新增方法）
        getCurrentTime() {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        }
    }
}
</script>


<style lang="scss" scoped>
.compliance-content {
    .grid.grid-cols-3 {
        .flex.items-start {
            // 主要边框
            border: 1px solid #e5e7eb;
            border-top: 1px solid #f3f4f6; // 顶部边框稍亮

            // 底部阴影（强调下部分）
            box-shadow:
                0 1px 2px 0 rgba(0, 0, 0, 0.05), // 轻微整体阴影
                0 4px 6px -2px rgba(0, 0, 0, 0.1), // 底部主要阴影
                0 2px 4px -1px rgba(0, 0, 0, 0.06) inset; // 内阴影增加深度

            // 悬停时底部阴影更明显
            &:hover {
                border-color: #3b82f6;
                box-shadow:
                    0 4px 6px -1px rgba(59, 130, 246, 0.1),
                    0 10px 15px -3px rgba(59, 130, 246, 0.1),
                    0 2px 4px -1px rgba(59, 130, 246, 0.06) inset;
                transform: translateY(-2px);
            }

            border-radius: 0.75rem;
            background-color: white;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

            // 创建底部高光效果
            position: relative;

            &::after {
                content: '';
                position: absolute;
                bottom: -1px;
                left: 0;
                right: 0;
                height: 1px;
                background: linear-gradient(90deg,
                        transparent 0%,
                        rgba(59, 130, 246, 0.1) 50%,
                        transparent 100%);
                opacity: 0;
                transition: opacity 0.3s ease;
            }

            &:hover::after {
                opacity: 1;
            }
        }
    }

    // 响应式样式
    @media (max-width: 768px) {

        // AI 核心审查技术矩阵 - 移动端纵向排列
        .max-w-\[1200px\] .grid.grid-cols-3 {
            grid-template-columns: 1fr !important;
            gap: 1.5rem;

            .flex.items-start {
                flex-direction: column;
                align-items: center;
                text-align: center;
                padding: 1.5rem;

                .iconify {
                    margin-bottom: 1rem;
                    margin-right: 0;
                }

                h5 {
                    font-size: 1.125rem;
                    margin-bottom: 0.5rem;
                }

                p {
                    font-size: 0.875rem;
                }
            }
        }

        // 精准化审查维度 - 移动端纵向排列
        .py-20 .grid.grid-cols-4 {
            grid-template-columns: 1fr !important;
            gap: 1.5rem;

            .bg-white {
                padding: 1.5rem;
                text-align: center;

                .inline-block {
                    margin: 0 auto 1.5rem auto;
                }

                h4 {
                    font-size: 1.125rem;
                    margin-bottom: 0.75rem;
                }

                p {
                    font-size: 0.875rem;
                    line-height: 1.5;
                }
            }
        }

        // 调整AI审查流程流转图的布局
        .flex.items-center.justify-between.relative {
            flex-direction: column;
            gap: 3rem;

            .absolute.top-\[40px\] {
                display: none; // 隐藏连接线
            }

            .flex.flex-col.items-center {
                width: 100%;

                .w-20.h-20 {
                    width: 4rem;
                    height: 4rem;
                }

                h5 {
                    font-size: 1rem;
                    margin-top: 1rem;
                }

                p {
                    font-size: 0.75rem;
                }
            }
        }

        // 优势对比模块响应式
        .grid.grid-cols-2 {
            grid-template-columns: 1fr !important;
            gap: 2rem;

            .space-y-6 {
                text-align: center;

                h3 {
                    font-size: 1.75rem;
                }

                ul {
                    text-align: left;
                    padding-left: 1rem;
                }
            }

            .bg-white.p-2 {
                margin-top: 1rem;

                .absolute.-bottom-6.-left-6 {
                    position: relative;
                    bottom: 0;
                    left: 0;
                    margin-top: 1rem;
                    width: 100%;
                }
            }
        }

        // 底部联系区响应式
        .bg-white.border.rounded-xl.p-8.flex {
            flex-direction: column;
            gap: 1.5rem;
            text-align: center;

            .flex.items-center.space-x-6 {
                flex-direction: column;
                gap: 1rem;

                .w-16.h-16 {
                    width: 4rem;
                    height: 4rem;
                }
            }

            .flex.space-x-4 {
                width: 100%;
                justify-content: center;

                button {
                    padding: 0.5rem 1.5rem;
                    font-size: 0.875rem;
                }
            }
        }
    }

    // 平板设备适配 (768px - 1024px)
    @media (min-width: 769px) and (max-width: 1024px) {

        // AI 核心审查技术矩阵 - 平板端2列
        .max-w-\[1200px\] .grid.grid-cols-3 {
            grid-template-columns: repeat(2, 1fr) !important;
        }

        // 精准化审查维度 - 平板端2列
        .py-20 .grid.grid-cols-4 {
            grid-template-columns: repeat(2, 1fr) !important;
        }

        // AI审查流程流转图 - 平板端调整
        .flex.items-center.justify-between.relative {
            flex-wrap: wrap;
            justify-content: center;
            gap: 2rem;

            .flex.flex-col.items-center {
                width: 30%;
                margin-bottom: 2rem;
            }

            .absolute.top-\[40px\] {
                display: none;
            }
        }
    }

    .grid.grid-cols-3 {
        .flex.items-start {
            // ... existing styles ...
        }
    }

    // 机器人图标响应式调整
    @media (max-width: 1350px) {
        .absolute.inset-0.opacity-30 {
            .iconify {
                right: 10% !important;
            }
        }
    }

    @media (max-width: 1023px) {
        .absolute.inset-0.opacity-30 {
            .iconify {
                display: none !important;
            }
        }
    }

    // 弹窗动画
    .fixed.inset-0 {
        animation: fadeIn 0.3s ease-out;

        .bg-white {
            animation: slideUp 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        }
    }

    // 成功提示动画
    .animate-slide-in {
        animation: slideInRight 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
        }

        to {
            opacity: 1;
        }
    }

    @keyframes slideUp {
        from {
            opacity: 0;
            transform: translateY(20px) scale(0.95);
        }

        to {
            opacity: 1;
            transform: translateY(0) scale(1);
        }
    }

    @keyframes slideInRight {
        from {
            opacity: 0;
            transform: translateX(100%);
        }

        to {
            opacity: 1;
            transform: translateX(0);
        }
    }

    // 响应式调整
    @media (max-width: 768px) {
        // ... existing responsive styles ...

        // 弹窗响应式
        .fixed.inset-0 {
            padding: 1rem;
            align-items: flex-end;

            .bg-white {
                width: 100%;
                max-width: 100%;
                border-radius: 1rem 1rem 0 0;
                animation: slideUpMobile 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
            }
        }

        @keyframes slideUpMobile {
            from {
                transform: translateY(100%);
            }

            to {
                transform: translateY(0);
            }
        }

        // 成功提示响应式
        .fixed.top-6.right-6 {
            top: auto;
            bottom: 1rem;
            right: 1rem;
            left: 1rem;
            animation: slideUpMobile 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        }
    }

    // 平板设备适配
    @media (min-width: 769px) and (max-width: 1024px) {
        .fixed.inset-0 {
            .bg-white {
                max-width: 90%;
            }
        }
    }

}
</style>